// extracted by mini-css-extract-plugin
export var dividerContainer = "_95-0";
export var line = "_95-1";